<template>
   <div :style="containerStyle">
      <div
         v-for="(file, index) in files"
         :key="file.id || file.name || index"
         class="d-flex align-items-start project-section justify-content-between"
      >
         <div class="d-flex flex-row align-items-center">
            <img src="@/assets/img/document-icon.svg" class="file-icon" alt="document" />
            <div class="d-flex align-items-center file-content-row">
               <div class="d-flex flex-column file-info-col">
                  <div class="file-name">
                     {{ file.name }}
                  </div>
                  <div class="file-size">File size: {{ formatSize(file.size) }}</div>
               </div>
               <div class="d-flex flex-column account-name-col" v-if="file.description">
                  <div class="account-name-label">Account Name</div>
                  <div class="account-name">{{ file.description }}</div>
               </div>
            </div>
         </div>
         <button
            :id="`btn-delete-vendor-${file.id || file.name || index}`"
            class="icon-btn delete-button"
            type="button"
            @click="deleteFile(file.id, file.uploadCategoryId)"
         >
            <img src="@/assets/img/delete.png" style="width: 22px; height: 28px" alt="delete" />
         </button>
      </div>
      <div v-if="emptyText && !files.length" class="text-muted small">
         {{ emptyText }}
      </div>
   </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {SpecialCategories} from '@/store/modules/uploads';

export default {
   name: 'FilesList',
   props: {
      categoryName: {
         type: String,
         required: true,
      },
      category: {
         type: String,
         required: true,
      },
      contractorId: {
         type: [String, Number],
         default: null,
      },
      height: {
         type: [String, Number],
         default: '150px',
      },
      emptyText: {
         type: String,
      },
      confirmMessage: {
         type: String,
         default: 'Are you sure you want to delete this uploaded document?',
      },
   },
   computed: {
      ...mapGetters({
         uploadCategories: 'uploads/uploadCategories',
      }),
      uploadCategory() {
         return this.uploadCategories.find(({name}) => name === this.categoryName);
      },
      files() {
         const files = this.uploadCategory?.summary || [];
         if (
            this.contractorId === null ||
            this.contractorId === undefined ||
            this.contractorId === ''
         ) {
            return files;
         }

         return files.filter((file) => {
            const fileContractorId =
               file?.validation?.data?.contractorId ?? file?.contractorId ?? null;
            return String(fileContractorId) === String(this.contractorId);
         });
      },
      containerStyle() {
         return {
            maxHeight: typeof this.height === 'number' ? `${this.height}px` : this.height,
            overflowY: 'auto',
         };
      },
   },
   methods: {
      formatSize(bytes) {
         if (!bytes && bytes !== 0) return '-';
         if (bytes < 1024) return `${bytes} B`;
         if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} kB`;
         return `${(bytes / 1048576).toFixed(1)} MB`;
      },
      async deleteFile(fileId, uploadCategoryId) {
         const proceed = await this.$bvModal.msgBoxConfirm(this.confirmMessage, {
            id: 'modal-confirm-delete',
            title: 'Delete this document?',
            centered: true,
            okVariant: 'danger',
         });
         if (!proceed) return;
         try {
            const currentFile = this.files.find((file) => String(file.id) === String(fileId));
            await this.$store.dispatch('uploads/deleteFile', {
               fileId,
               uploadCategoryId,
               periodId: currentFile?.periodId ?? null,
               force: true,
            });
            this.$emit('files-changed', this.files.length);
         } catch (error) {
            console.error('Error deleting file:', error);
         }
      },
   },
   async created() {
      if (this.category && SpecialCategories[this.category]) {
         await this.$store.dispatch('uploads/loadSpecialCategory', {
            companyId: this.$companyId,
            category: this.category,
         });
      }
      this.$emit('files-changed', this.files.length);
   },
};
</script>

<style scoped lang="scss">
.project-section {
   border-radius: 5px;
   background-color: #f9f9f9;
   padding: 10px 25px;
   margin-bottom: 10px;
   flex-direction: row;
   min-width: 100%;
   height: 60px;
}

.file-icon {
   margin-right: 15px;
}

.file-content-row {
   gap: 20px;
}

.file-info-col {
   width: 250px;
}

.file-name {
   font-size: 13px;
   font-weight: 600;
   margin-bottom: 2px;
}

.file-size {
   font-size: 11px;
   color: #666666;
   margin-bottom: 0;
   font-weight: 400;
}

.account-name-col {
   min-width: 120px;
}

.account-name-label {
   font-size: 11px;
   color: #666666;
   font-weight: 400;
}

.account-name {
   font-size: 13px;
   font-weight: 600;
}

.delete-button {
   color: grey !important;
}

::v-deep .modal-header {
   border-bottom: none !important;
   padding-bottom: 0 !important;
}

::v-deep .modal-footer {
   border-top: none !important;
}

::v-deep .modal-dialog {
   @media (max-width: 992px) {
      max-width: 90%;
   }
}
</style>
